import { FILTER_DISPLAY } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { RangeField } from "@/modules/Dashboards/AdminDashboard/models/RangeField";
import {
  SecondaryFilter,
  SecondaryFilterOptions
} from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { TreeChildren } from "@/modules/Dashboards/AdminDashboard/models/TreeChilden";
import { SELECT_EVENTS } from "@/shared/constants/SelectConstants";
import { Utils } from "@/shared/utils/utils";
import { Component, Prop, Vue } from "vue-property-decorator";
import { EVENT_EMITTER } from "../../constants/GenericSearchConstants";
import { FilterData, ObjFilterList } from "../../model/List";
import FilterTypeDate from "./../FilterTypeDate/FilterTypeDate.vue";
import FilterTypeInput from "./../FilterTypeInput/FilterTypeInput.vue";
import FilterTypeRange from "./../FilterTypeRange/FilterTypeRange.vue";
import FilterTypeSelect from "./../FilterTypeSelect/FilterTypeSelect.vue";
import FilterTypeShema from "./../FilterTypeShema/FilterTypeShema.vue";
import FilterTypeShemaRange from "./../FilterTypeShemaRange/FilterTypeShemaRange.vue";
import FilterTypeUnique from "./../FilterTypeUnique/FilterTypeUnique.vue";

@Component({
  name: "FilterTypeAll",
  components: {
    FilterTypeInput,
    FilterTypeSelect,
    FilterTypeRange,
    FilterTypeDate,
    FilterTypeUnique,
    FilterTypeShema,
    FilterTypeShemaRange
  }
})
export default class FilterTypeAll extends Vue {
  @Prop() itemFilter!: SecondaryFilter;
  @Prop() selectFilter!: ObjFilterList[];
  @Prop() filterData!: FilterData[];
  @Prop() isMultipleOption!: boolean;
  @Prop({ default: () => false }) isPrincipal!: boolean;
  @Prop({ default: () => [] }) ItemsShemaRange!: RangeField[];
  @Prop({ default: () => [] }) itemsSchema!: TreeChildren[];
  @Prop({ default: () => "" }) attachRef!: string;

  FILTER_DISPLAY = FILTER_DISPLAY;

  callData(data: SecondaryFilterOptions) {
    this.$emit(EVENT_EMITTER.CALL_DATA, data);
  }

  editData(data: SecondaryFilterOptions) {
    this.$emit(EVENT_EMITTER.EDIT_DATA, data);
  }

  get selectFilterLocal() {
    return this.selectFilter;
  }

  set selectFilterLocal(filterSelected: ObjFilterList[]) {
    this.$emit(EVENT_EMITTER.UPDATE_SELECT_FILTER, filterSelected);
    this.notificationChildern();
  }

  change() {
    this.$emit(EVENT_EMITTER.CHANGE);
  }

  fetchData(keyWord: string) {
    this.$emit(SELECT_EVENTS.EMITTERS.FETCH_DATA, keyWord);
  }

  notificationChildern() {
    const childrenReload = this.itemFilter.childrenReload;
    if (childrenReload?.length) {
      this.$emit(EVENT_EMITTER.CHILDREN_RELOAD, childrenReload);
    }
  }
  detectScroll() {
    Utils.detectScroll(this.$refs, "filterTypeSelect");
  }
}
